export default __webpack_public_path__ + "static/media/Robyn_9781408327913.6dc83113.jpg";